import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, Bell, Menu } from "lucide-react";
import { useMobile } from "@/context/MobileContext";

const iconBtn = "grid h-10 w-10 shrink-0 place-items-center rounded-full transition-colors hover:bg-white/15 active:bg-white/25";

export function MTopBar({ title, back, right }) {
  const { setDrawer, unread } = useMobile();
  const nav = useNavigate();
  return (
    <header className="sticky top-0 z-30 flex h-14 items-center gap-1 bg-[#1565c0] px-2 text-white shadow-md shadow-blue-900/20" data-testid="m-topbar">
      {back ? (
        <button className={iconBtn} onClick={() => nav(back === true ? -1 : back)} aria-label="Voltar" data-testid="m-back-btn"><ArrowLeft className="h-6 w-6" /></button>
      ) : (
        <button className={iconBtn} onClick={() => setDrawer(true)} aria-label="Abrir menu" data-testid="m-menu-btn"><Menu className="h-6 w-6" /></button>
      )}
      <p className="flex-1 truncate px-1 font-display text-lg font-semibold" data-testid="m-page-title">{title}</p>
      {right}
      <Link to="/m/notificacoes" className={`${iconBtn} relative`} aria-label="Notificações" data-testid="m-notif-btn">
        <Bell className="h-5 w-5" />
        {unread > 0 && <span className="absolute right-0.5 top-0.5 grid h-4 min-w-4 place-items-center rounded-full bg-red-500 px-1 text-[10px] font-bold" data-testid="m-notif-count">{unread > 9 ? "9+" : unread}</span>}
      </Link>
    </header>
  );
}

function Cell({ label, value, testId }) {
  return (
    <div className="min-w-0">
      <p className="text-[10px] font-semibold uppercase tracking-wider text-[#1565c0]/70">{label}</p>
      <p className="truncate font-semibold" data-testid={testId}>{value}</p>
    </div>
  );
}

export function SaleBar() {
  return (
    <div className="sticky top-14 z-20 border-b border-[#bbdefb] bg-[#e3f2fd] px-4 py-3 text-[#0d47a1]" data-testid="m-sale-bar">
      <p className="font-display text-lg font-bold leading-tight" data-testid="m-bar-new-sale">Nova Venda</p>
    </div>
  );
}

export function ComandaBar({ c }) {
  return (
    <div className="sticky top-14 z-20 grid grid-cols-[1.6fr_1fr_1fr] gap-3 border-b border-[#bbdefb] bg-[#e3f2fd] px-4 py-2.5 text-[#0d47a1]" data-testid="m-comanda-bar">
      <Cell label="Nome" value={c.customer_name || "Sem nome"} testId="m-bar-name" />
      <Cell label="Comanda" value={`#${c.number}`} testId="m-bar-number" />
      <Cell label="Mesa" value={c.table_number || "—"} testId="m-bar-table" />
    </div>
  );
}
